export default [
  {
    path: "/order",
    name: "order.order",
    redirect: "/order/0",
    title: "我的订单",
    component: () => import("./Order"),
    children: [
      {
        path: "/order/:active",
        name: "order.list",
        meta: {
          title: "我的订单",
          unback: true,
          noheader: true,
          unpull: true,
        },
        component: () => import("./children/OrderList"),
      },
    ],
  },
  {
    path: "orderdetail",
    name: "order.detail",
    meta: {
      title: "订单详情",
      unpull: true,
    },
    component: () => import("./OrderDetail"),
  },
  {
    path: "upgrade/order",
    name: "upgrade.order",
    meta: {
      title: "升级订单",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./UpgradeOrder"),
  },
  {
    path: "upgrade/pay",
    name: "upgrade.pay",
    meta: {
      title: "订单支付",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./UpgradePay"),
  },
];
